import Axios from 'axios'

const URL = 'https://www.heywhale.com'

const Api = Axios.create({
  baseURL: process.env.NODE_ENV === 'development' ? URL : '/',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json; charset=utf-8'
  }
})


/**
 * api拦截器
 * 处理异常
 */
Api.interceptors.response.use(function (response) {
  return response.data
}, function (error) {
  error.message = `网络错误${error.response.status}`
  return Promise.reject(error)
})

export function leaderboard () {
  return Api.get(`/v2/api/competitions/60618cb821e3f6003b56b207/invitation/leaderboard`)
  // return Api.get('./data/leaderboard.json')
}

// 获取海报code
export function getInvitationCode() {
  return Api.get(`/v2/api/competitions/60618cb821e3f6003b56b207/invitation/code`)
}

export function getDigitaList () {
  // return Api.get(`/v2/api/tasks/607d2fbc65852e0017ab961d/leaderboard`)
  return Api.get(`/v2/api/tasks/607d30a765852e0017ab963c/leaderboard`)

}